import { createCombineMapItem } from '../../../../../reducerRegistry';

import { createReduceObject as participateContestFormCreateReduceObject } from './participateContest/participateContestForm';
import participateContestFormSaga from './participateContest/participateContestFormSaga';

export default [
  // Forms
  ...createCombineMapItem(
    'participateContestForm',
    participateContestFormCreateReduceObject,
    [participateContestFormSaga]
  )
];



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/contests/reducers/static/forms/reducersMap.js